import { useState } from 'react';

const HEADER_HEIGHT = 64;

const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '更新动态', href: '#updates' },
  { label: '平台优势', href: '#features' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70"
      style={{ height: HEADER_HEIGHT }}
    >
      <div className="h-full max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between">
        <a
          href="#hero"
          className="font-heading text-xl md:text-2xl font-bold text-foreground-900 whitespace-nowrap tracking-wide"
        >
          耽美漫画网
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-3 flex flex-col gap-2">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors py-2"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}